import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const permissionsScreenModule = defineScreen({
  app: "coaching",
  screen_id: "permissions",
  path: "/permissions",
  heading: { text: "Permissions", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "deny",
    "coach": "deny",
    "company_admin": "deny",
    "participant": "deny",
    "cohort_lead": "deny"
  },
  states: ["ready"],
  actions: [
    { id: "sort", kind: "secondary", driver: "table.sort" },
    { id: "filter", kind: "secondary", driver: "table.filter" },
    { id: "paginate", kind: "secondary", driver: "table.paginate" },
    { id: "row-open", kind: "row", driver: "table.rowOpen" }
  ],
  recipe: "ProTable-1",
  data: { seedNeeds: ["readonly-walk-session", "populated-list-min1"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/permissions.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default permissionsScreenModule;
